{
  "dashboards": {
    "list": {
      "navigation_title": "Lista de Paneles de Control",
      "title": "Lista de Paneles de Control"
    },
    "navigation_title": "Paneles de Control",
    "title": "Paneles de Control",
    "add_dashboard": "Nuevo Panel de Control",
    "new_dashboard": "Nuevo Panel de Control",
    "open_dashboard": "Abrir Panel de Control",
    "add_widgets": "Añadir Widgets",
    "widget_groups": {
      "data": "Datos y Tendencias",
      "location": "Ubicación"
    },
    "widget_descriptions": {
      "chart_widget": "Líneas temporales superpuestas",
      "heatmap_widget": "Cuadrícula de últimos valores coloreada por estado",
      "node_widget": "Tarjeta de estado con los últimos valores",
      "map_widget": "Vista geoespacial de las ubicaciones de dispositivos",
      "wind_rose_widget": "Distribución de dirección y velocidad del viento",
      "connectivity_widget": "Línea de tiempo en línea/fuera de línea por dispositivo",
      "distribution_widget": "Distribución de las lecturas de un parámetro por dispositivo"
    },
    "not_found": "Ningún panel de control coincide con los filtros actuales",
    "visibility": {
      "shared": "Compartido",
      "shared_hint": "Todos en la organización ven este panel; sus administradores lo editan"
    },
    "share": {
      "title": "Compartir Panel de Control",
      "hint": "Todos en la organización verán este panel. Solo sus administradores podrán editarlo."
    },
    "starred": "Destacado",
    "unshare": {
      "action": "Dejar de compartir",
      "title": "¿Hacer privado este panel?",
      "text": "Pasará a ser tu panel privado. Los demás en la organización ya no lo verán.",
      "confirm": "Hacer privado",
      "done": "El panel ahora es privado para ti"
    }
  }
}
